import moment, { Moment } from "moment";
import { PaginationInquiry } from "../../../../helper/pagination";
import { Action, CustomerUI } from "../../customer/entity/customer.model";
import { PromotionUI } from "../../promotion/entity/promotion.model";
import { User } from "../../user/entity/user.model";

export interface PlanBase {
  uuid?: string;
  planType?: PlanType;
  amount: number;
  username?: string;
  customerId?: string;
  companyCode?: string;
  brandId?: string;
  promotionId?: string;
  name: string;
  routeId?: string;
}

export interface PlanFilter extends PaginationInquiry {
  username?: string;
  planType?: PlanType;
  startDate?: string;
  endDate?: string;
  routeId?: string;
}

export interface Plan extends PlanBase {
  startDate: string;
  endDate: string;
}

export interface PlanUI extends PlanBase {
  user?: User;
  key?: number;
  index?: number;
  actions?: Action[];
  promotion?: PromotionUI;
  startDate?: Moment;
  endDate?: Moment;
  month?: number;
  customer?: CustomerUI;
}

export enum PlanType {
  BRAND = "BRAND",
  PROMOTION = "PROMOTION",
  CUSTOMER = "CUSTOMER",
  EMPTY = "EMPTY",
  ALL = "ALL",
}
